/* eslint-disable react-hooks/exhaustive-deps */
import { Image, ScrollView, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { ProductItem } from '../components/ProductItem/ProductItem.type';
import { styles } from './EshopDetailPage.style';
import { useNavigation } from '@react-navigation/native';
import { NavigationService } from '../../../services/navigation';
import { Footer } from '../../../components/Footer';
import { ProductItem as ProductItemComponent } from '../components';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { EShopLayout } from '../../../WebLayout';
import { COLORS, FONTS } from '../../../constants';
import ProductItemTable from '../components/ProductItemTable';
import { EShopDetailPageProps } from './EshopDetailPage.types';
import { Product } from '../../../types/woocommerce.types';
import { wooCommerceApi } from '../../../services/api/wooCommerceApi';
import { Loading } from '../../../components';
import RenderHTML from 'react-native-render-html';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import { IProduct } from '../../../models/IProduct';
import { addToCart, updateCart } from '../../../services/redux/reducers/CartSlice';
import ProductWooItemTable from '../components/ProductWooItemTable';
import ProductWooItem from '../components/ProductWooItem';
import { getContentWidth } from '../../../constants/platform';
import { Alert } from '../../../services/alert';

const productSelect: ProductItem = {
  id: 'hfjdla',
  name: 'Boadraeux wine 1977',
  desc: 'Lorem ipsum dolor sit amet, consectetur adng elitor sit aaectet.',
  price: 234.0,
  thumbnail:
    'https://product.hstatic.net/200000311961/product/ruou-vang-do-aromo-carmenere_da6e1c4302a94f17a8eb5a873fd75eab.jpg',
};
const similarProducts: ProductItem[] = [
  {
    id: 'hfjdla1',
    name: 'Boadraeux wine 1977',
    desc: 'Lorem ipsum dolor sit amet, consectetur adng elitor sit aaectet.',
    price: 234.0,
    thumbnail:
      'https://product.hstatic.net/200000311961/product/ruou-vang-do-aromo-carmenere_da6e1c4302a94f17a8eb5a873fd75eab.jpg',
  },
  {
    id: 'hfjdla2',
    name: 'Boadraeux wine 1977',
    desc: 'Lorem ipsum dolor sit amet, consectetur adng elitor sit aaectet.',
    price: 234.0,
    thumbnail:
      'https://product.hstatic.net/200000311961/product/ruou-vang-do-aromo-carmenere_da6e1c4302a94f17a8eb5a873fd75eab.jpg',
  },
  {
    id: 'hfjdla3',
    name: 'Boadraeux wine 1977',
    desc: 'Lorem ipsum dolor sit amet, consectetur adng elitor sit aaectet.',
    price: 234.0,
    thumbnail:
      'https://product.hstatic.net/200000311961/product/ruou-vang-do-aromo-carmenere_da6e1c4302a94f17a8eb5a873fd75eab.jpg',
  },
  {
    id: 'hfjdla4',
    name: 'Boadraeux wine 1977',
    desc: 'Lorem ipsum dolor sit amet, consectetur adng elitor sit aaectet.',
    price: 234.0,
    thumbnail:
      'https://product.hstatic.net/200000311961/product/ruou-vang-do-aromo-carmenere_da6e1c4302a94f17a8eb5a873fd75eab.jpg',
  },
  {
    id: 'hfjdla5',
    name: 'Boadraeux wine 1977',
    desc: 'Lorem ipsum dolor sit amet, consectetur adng elitor sit aaectet.',
    price: 234.0,
    thumbnail:
      'https://product.hstatic.net/200000311961/product/ruou-vang-do-aromo-carmenere_da6e1c4302a94f17a8eb5a873fd75eab.jpg',
  },
];
const EShopDetailPage: FC<EShopDetailPageProps> = ({
  navigation,
  route,
}) => {
  const productId = route.params.id;
  const nav = useNavigation();
  const [product, setProduct] = useState<Product>();
  const [recommendProducts, setRecommendProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoadingProducts, setIsLoadingProducts] = useState<boolean>(true);
  const [count, setCount] = useState<number>(1);
  const isDesktop = useIsDesktop();
  const { items } = useSelector((redux: RootState) => redux.cartReducer);
  const dispatch = useDispatch();

  const getProduct = useCallback(
    async (productId: number) => {
      try {
        setIsLoading(true);
        const res = await wooCommerceApi.get(`products/${productId}`);
        setProduct(res.data);
      } catch (error: any) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const getRecommendProducts = useCallback(
    async () => {
      try {
        setIsLoadingProducts(true);
        const res = await wooCommerceApi.get('products', {
          per_page: 5,
          category: product?.categories[0].id,
          status: 'publish',
          orderby: 'popularity',
          exclude: [product?.id]
        });
        setRecommendProducts(res.data);
      } catch (error: any) {
        console.log(error);
      } finally {
        setIsLoadingProducts(false);
      }
    },
    [product]
  );

  const handleAddCart = useCallback(
    () => {
      if (product) {
        let isAdded = false;

        if (items.filter(e => e.id === product.id).length > 0) {
          isAdded = true;
        }
  
        if (isAdded) {
          const newCartData: IProduct[] = items.map((data) => {
            if (data.id === product.id) {
              return {
                ...data,
                amount: data.amount + count
              };
            }
            return data;
          });
          dispatch(updateCart(newCartData));
        } else {
          dispatch(addToCart({
            id: product.id,
            photo: product.images[0]?.src ?? '',
            totalAmount: count,
            amount: count,
            price: parseFloat(product.price),
            type: product.categories[0].name ?? '',
            productName: product.name,
          }));
        }
        
        Alert.alert('Product added to your cart!', '', [
          {
            text: 'Go to Checkout',
            onPress: () => {
              NavigationService.navigate('EShopCheckout');
            },
          },
          {
            text: 'Continue Shopping',
            onPress: () => {
            },
          },
        ]);
      }
    },
    [product, count, items, dispatch]
  );

  const handleChangeAmount = useCallback(
    (type: 'increase' | 'decrease') => {
      if (type === 'decrease' && count > 1) {
        setCount(count - 1);
      }

      if (type === 'increase'
        // && product.stock_status !== 'outofstock'
        // && product.stock_quantity > count
      ) {
        setCount(count + 1);
      }
    },
    [count, product]
  );

  useEffect(() => {
    if (product && product.categories[0].id) {
      getRecommendProducts();
    }
  }, [product])

  useEffect(() => {
    getProduct(productId);
  }, [productId]);

  const handleBack = () => {
    if (nav.canGoBack()) {
      NavigationService.goBack();
    } else {
      NavigationService.replace('Root', { screen: 'HomeTab' });
    }
  };

  const renderProductDetail = useCallback(() => {
    if (product) {
      if (isDesktop()) {
        return (
          <View>
            <View style={{
              marginBottom: 40,
            }}>
              <View style={{
                flexDirection: 'row',
                marginTop: 20,
                marginBottom: 40,
              }}>
                <View style={{
                  width: '30%',
                }}>
                  <Image
                    source={{ uri: product.images[0].src }}
                    style={{
                      width: '100%',
                      height: 300,
                      borderColor: COLORS.DARK_GREY,
                      borderWidth: 1,
                    }}
                  />
                </View>
                <View style={{
                  flex: 1,
                  paddingLeft: 20,
                }}>
                  <Text style={styles.contentName}>{product.name}</Text>
                  <View
                    style={{
                      width: 40,
                      height: 4,
                      backgroundColor: STYLE_VARS.primaryColor,
                    }}
                  />
                  <Text style={[styles.priceText, {
                    fontWeight: '500',
                    marginBottom: 10,
                  }]}>
                    {/* {`HK$ ${(
                      Math.round(product?.price! * 100) / 100
                    ).toFixed(2)}`} */}
                    {`$${product.price}`}
                  </Text>
                  <Text style={[styles.contentDesc, {marginBottom: 5, fontSize: 16}]}>
                    <RenderHTML
                      source={{ html: product.short_description }}
                      tagsStyles={{
                        p: {
                          marginTop: 0,
                          fontSize: 14,
                          fontFamily: STYLE_VARS.avenirMediumFont,
                          color: '#606060',
                          textTransform: 'uppercase',
                          fontWeight: '500',
                          marginBottom: 10,
                        }
                      }}
                    />
                  </Text>
                  <View style={styles.countWrapper}>
                    <View style={styles.count}>
                      <TouchableOpacity
                        activeOpacity={1}
                        style={[styles.countBtn, {
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }]}
                        onPress={() => handleChangeAmount('decrease')}
                      >
                        <Text style={styles.countBtnText}>-</Text>
                      </TouchableOpacity>
                      <Text style={[styles.countText, {
                        fontSize: 15,
                        paddingHorizontal: 20,
                      }]}>
                        {count}
                      </Text>
                      <TouchableOpacity
                        activeOpacity={1}
                        style={[styles.countBtn, {
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }]}
                        onPress={() => handleChangeAmount('increase')}
                      >
                        <Text style={styles.countBtnText}>+</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                  <View style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: 20,
                  }}>
                    <Button
                      text={'ADD TO CART'}
                      style={STYLE_VARS.blueButton}
                      onPress={() => {
                        handleAddCart();
                      }}
                    />
                    <TouchableOpacity style={{
                      marginLeft: 10,
                    }}>
                      <Image
                        source={require('../../../assets/share-icon.png')}
                        style={{
                          width: 20,
                          height: 20,
                        }}
                      />
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
              <View>
                <Text style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontSize: 18,
                  textTransform: 'uppercase',
                  color: COLORS.GREEN,
                  marginBottom: 10,
                  letterSpacing: 1,
                }}>{product.name}</Text>
                <Text
                  style={[styles.contentDesc, {
                    letterSpacing: 1,
                  }]}
                >
                  <RenderHTML
                    source={{ html: product.short_description }}
                    tagsStyles={{
                      p: {
                        marginTop: 0,
                        fontSize: 14,
                        fontFamily: STYLE_VARS.avenirMediumFont,
                        color: '#606060',
                        textTransform: 'uppercase',
                        fontWeight: '500',
                        marginBottom: 10,
                      }
                    }}
                  />
                </Text>
              </View>
            </View>
          </View>
        )
      }

      return (
        <View style={styles.wrapper}>
          <View style={styles.detailWrapper}>
            <TouchableOpacity style={styles.backOption} onPress={handleBack}>
              <Image
                source={require('../../../assets/left-arrow.png')}
                style={{
                  height: 14,
                  width: 10,
                  resizeMode: 'contain',
                  tintColor: STYLE_VARS.primaryColor,
                }}
              />
            </TouchableOpacity>
            <View style={styles.thumbnailWrapper}>
              <Image
                style={styles.thumbnail}
                source={{ uri: product.images[0].src }}
              />
            </View>
          </View>
          <View style={styles.contentText}>
            <Text style={styles.contentName}>{product.name}</Text>
            <Text style={styles.contentDesc}>
              <View style={{width: getContentWidth() - 40}}>
                <RenderHTML
                  contentWidth={getContentWidth() - 40}
                  source={{ html: product.description }}
                  tagsStyles={{
                    p: {
                      marginTop: 0,
                      fontSize: 14,
                      fontFamily: STYLE_VARS.avenirMediumFont,
                      color: '#606060',
                      textTransform: 'uppercase',
                      fontWeight: '500',
                      marginBottom: 10,
                    }
                  }}
                />
              </View>
            </Text>
            <Text style={styles.priceText}>
              {/* {`HK$ ${(
                Math.round(product?.price! * 100) / 100
              ).toFixed(2)}`} */}
              {`$${product.price}`}
            </Text>
          </View>
          <View style={styles.countWrapper}>
            <View style={styles.count}>
              <TouchableOpacity
                activeOpacity={1}
                style={styles.countBtn}
                onPress={() => handleChangeAmount('decrease')}
              >
                <Text style={styles.countBtnText}>-</Text>
              </TouchableOpacity>
              <Text style={styles.countText}>{count}</Text>
              <TouchableOpacity
                activeOpacity={1}
                style={styles.countBtn}
                onPress={() => handleChangeAmount('increase')}
              >
                <Text style={styles.countBtnText}>+</Text>
              </TouchableOpacity>
            </View>
            <View style={{ width: '55%', flexDirection: 'row' }}>
              <Button
                text="ADD TO CART"
                style={STYLE_VARS.fullWGreenButton}
                onPress={() => {
                  handleAddCart();
                }}
              />
            </View>
          </View>
        </View>
      );
    }
    return <></>;
  }, [product, count, isDesktop]);

  if (isDesktop()) {
    return (
      <EShopLayout
        title={product?.categories[0].name ?? ''}
        // icon={require('../../../assets/wines.png')}
        havePromotion={false}
        haveGoBackButton={true}
      >
        {isLoading === true
          ? <Loading/>
          : <>
            {renderProductDetail()}
            <View>
              <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: 20,
              }}>
                <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <Image
                    source={require('../../../assets/filter-button.png')}
                    style={{
                      width: 15,
                      height: 15,
                      marginRight: 5,
                    }}
                  />
                  <Text style={{
                    fontFamily: FONTS.IowanOldStyleBTRoman,
                    fontWeight: '500',
                    fontSize: 12,
                    color: COLORS.GREEN,
                    textTransform: 'uppercase',
                  }}>{'Filter'}</Text>
                </TouchableOpacity>
                <Text style={{
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                  fontWeight: '500',
                  fontSize: 20,
                  color: COLORS.GREEN,
                  textTransform: 'uppercase',
                  textAlign: 'center',
                }}>{product?.categories[0].name}</Text>
                <View style={{ width: 60 }}/>
              </View>
              <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingTop: 20,
                paddingHorizontal: 5,
                borderTopColor: COLORS.DARK_GREY,
                borderTopWidth: 1,
                paddingBottom: 10,
              }}>
                <View style={{ width: '20%'}}>
                  <Text style={styles.tableHeaderText}>Image</Text>
                </View>
                <View style={{ width: '20%'}}>
                  <Text style={styles.tableHeaderText}>Name</Text>
                </View>
                <View style={{ width: '25%'}}>
                  <Text style={styles.tableHeaderText}>Description</Text>
                </View>
                <View style={{ width: '10%'}}>
                  <Text style={styles.tableHeaderText}>Price</Text>
                </View>
                <View style={{ width: '15%'}}>
                  <Text style={styles.tableHeaderText}>Quantity</Text>
                </View>
              </View>
              {isLoadingProducts === true
                ? <Loading/>
                : <View>
                  {recommendProducts.map((item, index) => (
                    <ProductWooItemTable
                      key={item.id}
                      product={item}
                      haveImage={true}
                      type={index % 2 == 0 ? 'even' : 'obb'}
                      categoryName={product?.categories[0].name}
                    />
                  ))}
                </View>
              }
            </View>
          </>
        }
      </EShopLayout>
    )
  }

  return (
    <ScrollView>
      {isLoading === true
        ? <View
          style={{
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <Loading/>
        </View>
        : <>
          {renderProductDetail()}
          <View style={styles.similarProductsWrp}>
            <Text style={styles.similarProductsText}>Similar products</Text>
            {isLoadingProducts
              ? <Loading/>
              : <View>
                {recommendProducts.map((product, index) => {
                  return (
                    <ProductWooItem
                      product={product}
                      type="list"
                      key={index}
                      categoryName={product.categories[0].name}
                    />
                  );
                })}
              </View>
            }
            {/* <Button
              text={'BROWSE MORE WINES'}
              style={[STYLE_VARS.blueButton, { marginVertical: 30 }]}
            /> */}
          </View>
        </>
      }
      <Footer />
    </ScrollView>
  );
};

export default EShopDetailPage;
